import { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { my_routes } from "../router/all_routes";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Table from "../../core/common/dataTable/index";

import { TableData } from "../../core/data/interface";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useLocation } from "react-router-dom";

import { getUserPermissions } from "../../api/permissions";
import { getAllFunctionalities } from "../../api/permissions";
import { assignePermissions } from "../../api/permissions";

interface Permission {
  modules: string;
  view: boolean;
  created: boolean;
  edit: boolean;
  delete: boolean;
  update?: boolean;
  title?: string;
  key: number;
}

const RolesPermission = () => {
  const routes = my_routes;

  const location = useLocation();
  const routeState = (location.state as { userId?: string; name?: string } | null) ?? null;
  const userId = routeState?.userId ?? "";
  const name = routeState?.name ?? "Inconnu";

  const [isLoading, setIsLoading] = useState(true); // Pour le vrai chargement
  const [hasLoaded, setHasLoaded] = useState(false); // Pour éviter "Chargement..." quand il n'y a juste pas de données
  const [permissionData, setPermissionData] = useState<Permission[]>([]);
  const [initialUserPermission, setInitialUserPermission] = useState<any>([]);
  const [error, setError] = useState<string | null>(null);
  const [assignationLoading, setAssignementLoading] = useState(false);

  const columns = [
    {
      title: "Modules",
      dataIndex: "modules",
      render: (text: string, record: any, index: number) => {
        // console.log("recordreceived: ", record);
        return <div>{record?.title}</div>;
      },
      sorter: (a: TableData, b: TableData) =>
        a.modules.length - b.modules.length,
    },
    {
      title: "Lecture",
      dataIndex: "view",
      render: (text: string, record: any, index: number) => (
        <>
          <label className="checkboxs ">
            <input
              className="bg-white"
              type="checkbox"
              onChange={(e) =>
                togglePermission({ ...record, view: e.target.checked })
              }
              checked={record.view}
            />
            <span className="checkmarks border-2 border-black" />
          </label>
        </>
      ),
      sorter: (a: TableData, b: TableData) => a.view.length - b.view.length,
    },
    {
      title: "Création",
      dataIndex: "created",
      render: (text: string, record: any, index: number) => (
        <>
          <label className="checkboxs">
            <input
              className="border-2 border-black"
              type="checkbox"
              onChange={(e) =>
                togglePermission({ ...record, created: e.target.checked })
              }
              checked={record.created}
            />
            <span className="checkmarks border-2 border-black" />
          </label>
        </>
      ),
      sorter: (a: TableData, b: TableData) =>
        a.created.length - b.created.length,
    },

    {
      title: "Modification",
      dataIndex: "edit",
      render: (text: string, record: any, index: number) => (
        <>
          <label className="checkboxs">
            <input
              className="border-2 border-black"
              type="checkbox"
              onChange={(e) =>
                togglePermission({ ...record, edit: e.target.checked })
              }
              checked={record.edit}
            />
            <span className="checkmarks border-2 border-black" />
          </label>
        </>
      ),
      sorter: (a: TableData, b: TableData) => a.edit.length - b.edit.length,
    },
    {
      title: "Suppression",
      dataIndex: "delete",
      render: (text: string, record: any, index: number) => (
        <>
          <label className="checkboxs">
            <input
              type="checkbox"
              onChange={(e) => {
                togglePermission({ ...record, delete: e.target.checked });
                // console.log(record) ;
              }}
              checked={record.delete}
            />
            <span className="checkmarks border-2 border-black" />
          </label>
        </>
      ),
      sorter: (a: TableData, b: TableData) => a.delete.length - b.delete.length,
    },
  ];

  // Fonction pour récupérer les permissions de l'utilisateur
  const fetchUserPermissions = useCallback(async (userId: string) => {
    try {
      const response = await getUserPermissions(userId);
      const permissionsUser = response.data;

      setInitialUserPermission(permissionsUser);

      setPermissionData((prevPermissions) => {
        const updated = prevPermissions.map((perm) => ({ ...perm }));

        for (const item of permissionsUser) {
          const index = updated.findIndex(
            (perm) => perm.key === item.Functionality.id,
          );
          if (index !== -1) {
            switch (item.Permission.label) {
              case "read":
                updated[index].view = true;
                break;
              case "update":
                updated[index].edit = true;
                break;
              case "create":
                updated[index].created = true;
                break;
              case "delete":
                updated[index].delete = true;
                break;
            }
          }
        }

        return updated;
      });
    } catch (e: any) {
      if (e.status === 404) {
        return;
      }
      setError(
        "Erreur lors de la récupération des permissions de l'utilisateur.",
      );
    }
  }, []);

  const fetchAllFunctionalities = async () => {
    try {
      const response = await getAllFunctionalities();
      if (!response) {
        setIsLoading(false);
        setHasLoaded(true);
        return;
      }
      // console.log("Fonctionnalités récupérées avec succès:", response.data);
      const all_functionalities = response.data.data;

      const permissions = all_functionalities.map((item: any) => {
        return {
          modules: item.label,
          title: item.title,
          view: false,
          created: false,
          edit: false,
          delete: false,
          update: false, // Ajout de la propriété update
          key: item.id,
        };
      });
      setPermissionData(permissions);
      setIsLoading(false);
      setHasLoaded(true);
    } catch (error) {
      // console.log(
      //   "Erreur lors de la récupérations des fonctionnalités: ",
      //   error
      // );
      setError(` Erreur lors de la récupérations des fonctionnalités:
        ${error}`);
    }
  };

  const togglePermission = (permission: Permission) => {
    setPermissionData((prevPermissions) =>
      prevPermissions.map((perm) =>
        perm.key === permission.key
          ? { ...perm, ...permission, update: true }
          : perm,
      ),
    );
  };

  //Initialisation de sweetAlert
  const MySwal = withReactContent(Swal);

  const onSubmit = async () => {
    try {
      setAssignementLoading(true);
      const permissionWithouInitialStatePermission = permissionData.filter(
        (item) =>
          !initialUserPermission.some(
            (perm: any) =>
              perm.id === item.key &&
              ((perm.Permission.label === "read" && item.view === false) ||
                (perm.Permission.label === "update" && item.edit === false) ||
                (perm.Permission.label === "create" &&
                  item.created === false) ||
                (perm.Permission.label === "delete" && item.delete === false)),
          ),
      );

      const permissionWithStatutUpdated =
        permissionWithouInitialStatePermission.filter(
          (item) => item.update === true,
        );

      // Création des promesses
      const assignPromises = permissionWithStatutUpdated.map(async (item) => {
        let payload = {
          userId,
          functionality: item.modules,
          permissions: {
            read: item.view,
            update: item.edit,
            create: item.created,
            delete: item.delete,
          },
        };
        return assignePermissions(payload);
      });

      await Promise.all(assignPromises);
      // Si toutes les promesses ont été résolues
      setAssignementLoading(false);
      MySwal.fire({
        title: "Assignation des permissions effectuée avec succès !",
        icon: "success",
        confirmButtonText: "OK",
      });
    } catch (error: any) {
      // console.log("Erreur:", error);
      setAssignementLoading(false);
      setError(
        error.response?.data?.message ||
          error.response?.data?.error ||
          "Une erreur est survenu lors  de l'assignation des permissions .",
      );
    }
  };

  useEffect(() => {
    if (!userId) {
      setError("Aucun utilisateur sélectionné.");
      setIsLoading(false);
      setHasLoaded(true);
      setPermissionData([]);
      setInitialUserPermission([]);
      return;
    }

    setError(null);
    setIsLoading(true);
    setHasLoaded(false);
    setPermissionData([]);
    setInitialUserPermission([]);

    const fetchData = async () => {
      await fetchAllFunctionalities();
    };

    fetchData();
  }, [userId]);

  // Étape 2 : quand permissionData est bien chargé, on peut appliquer les permissions
  useEffect(() => {
    if (!userId || !hasLoaded) return;

    fetchUserPermissions(userId);
  }, [userId, hasLoaded, fetchUserPermissions]);

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Rôles & Permissions</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.allUser}>Compte</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Rôles & Permissions
                  </li>
                </ol>
              </nav>
            </div>
          </div>
          {/* /Page Header */}
          {error && (
            <div className="alert alert-danger rounded-pill alert-dismissible fade show">
              {error}
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="alert"
                aria-label="Close"
              >
                <i className="fas fa-xmark" />
              </button>
            </div>
          )}

          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Utilisateur : {name ? name : "Inconnu"}</h4>
              <div className="d-flex align-items-center flex-wrap">
                <div className="mb-2">
                  {assignationLoading ? (
                    <button
                      className="btn btn-primary-light w-100"
                      type="button"
                      disabled={true}
                    >
                      <span
                        className="spinner-border spinner-border-sm align-middle me-1"
                        role="status"
                        aria-hidden="true"
                      />
                      Loading...
                    </button>
                  ) : (
                    <button
                      className="btn btn-primary d-flex align-items-center"
                      onClick={onSubmit}
                    >
                      <i className="ti ti-square-rounded-plus me-2" />
                      Enregistrer
                    </button>
                  )}
                </div>
              </div>
            </div>
            <div className="card-body p-0 py-3">
              {/* Liste des permission de l'utilisateur */}
              {isLoading && !hasLoaded ? (
                <div className="text-center">
                  <div className="spinner-border" role="status"></div>
                  <span className="visually">Chargement des Données...</span>
                </div>
              ) : (
                <Table
                  columns={columns}
                  dataSource={permissionData}
                  Selection={true}
                />
              )}
              {/* /SListe des permission de l'utilisateur */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RolesPermission;
